// https://github.com/reduxjs/redux-toolkit/issues/520#issuecomment-699456947
export function withErrorHandling(payloadCreator) {
  return async (args, thunkAPI) => {
    try {
      return await payloadCreator(args, thunkAPI);
    } catch (error) {
      // Keep HTTP status for slice error handlers (e.g. 404 -> METHOD_NOT_FOUND).
      if (error && typeof error === 'object' && 'status' in error) {
        return thunkAPI.rejectWithValue(error);
      }

      return thunkAPI.rejectWithValue(error?.data || error);
    }
  };
}
